import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=a861b2a6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=a861b2a6&prod&lang=scss&scoped=true"
import style1 from "./Header.vue?vue&type=style&index=1&id=a861b2a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a861b2a6",
  null
  
)

export default component.exports